'use client';

import { useEffect } from 'react';
import { clientLogger } from '@/lib/client-logger';

/**
 * Initializes the client-side logger and global error handlers.
 * Place this component high in the component tree (e.g. in layout.tsx).
 *
 * Renders nothing — just wires up event listeners.
 */
export function LogProvider({ children }: { children: React.ReactNode }) {
	useEffect(() => {
		const cleanup = clientLogger.init();

		return cleanup;
	}, []);

	return <>{children}</>;
}
